import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConvertCurrencyService {
  private readonly apiUrl = `${environment.apiUrl}/currency-exchange/latest-rates`;

  constructor(private http: HttpClient) {}

  getCurrencyRates(base: string, currencies: string[]): Observable<any> {
    return this.http.get<any>(this.apiUrl, {
      params: {
        base,
        currencies: currencies.join(','),
      },
    });
  }

  getCurrencyRate(base: string, currency: string): Observable<any> {
    return this.getCurrencyRates(base, [currency]);
  }
}
